// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__182Pa","insightsList":"newBusinessInsightsMenu_insightsList__24ebj","active":"newBusinessInsightsMenu_active__iFh2D"};